<template>
  <IframeWrap :option="wrapSize" @loaded="handleLoad">
    <div
      v-if="loading"
      class="absolute left-0 top-0 flex flex-col w-full h-full justify-center items-center bg-gray-50"
    >
      <Loading />
      <div class="loading-text mt-1">加载中...</div>
    </div>

    <iframe
      ref="contentIframe"
      allowfullscreen="true"
      allow="camera;microphone;display-capture;clipboard-read;clipboard-write;"
      width="100%"
      frameborder="0"
      @load="handleLoad"
    ></iframe>
  </IframeWrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import IframeWrap from '@/components/iframe-wrap';
import { getChatGPTIframeUrl, IChatGPTConfig } from './util';
import { IIframewrap } from '@/components/iframe-wrap/type';
import Loading from '@/components/common/system-loading';

@Component({
  components: {
    IframeWrap,
    Loading
  }
})
export default class ChatGPTIframe extends Vue {
  @Prop({ type: Object }) content!: Content & IChatGPTConfig & IIframewrap;

  loading = true;

  isEnlarge = false;

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  async init() {
    const url = await getChatGPTIframeUrl(this.content);
    const iframeEl = this.$refs.contentIframe as HTMLIFrameElement;
    iframeEl.src = url;
    this.loading = false;
  }

  mounted() {
    this.init();
  }

  handleLoad() {
    this.$emit('loaded');
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}
.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}
.iframe {
  @apply w-full h-80 overflow-hidden bg-white;
}
.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center;
  flex: 0 0 2rem;
}

.loading-text {
  color: #8e8bff;
}
</style>
